import React from 'react';
import { Box, Typography, Paper, Avatar } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { getGreeting, getAvatarFallback } from '../utils/dashboardUtils';

/**
 * Dashboard hoş geldin kartı
 */
const WelcomeCard = ({ userData }) => {
  const { t } = useTranslation();

  return (
    <Paper className="welcome-card" elevation={0}>
      <Box className="welcome-content">
        <Avatar 
          className="welcome-avatar"
          src={userData?.logoUrl}
          alt={userData?.companyName || 'Hotel Logo'}
          sx={{ 
            width: 80, 
            height: 80,
            border: userData?.logoUrl ? 'none' : '2px solid #ccc'
          }}
        >
          {!userData?.logoUrl && getAvatarFallback()}
        </Avatar>
        <Typography className="welcome-title">
          {getGreeting(t)}, {userData?.companyName || userData?.name || t('hotel')}
        </Typography>
        <Typography className="welcome-subtitle">
          {t('dashboard_welcome')}
        </Typography>
      </Box>
    </Paper>
  );
};

export default WelcomeCard;
